<template>
  <div class="container has-text-centered">
    <div class="column is-4 is-offset-4">
      <h1 class="title has-text-grey">Error 404</h1>
      <h3 class="title has-text-grey">Página no encontrada</h3>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>

<style lang="scss" scoped>
h1 {
  text-align: center;
}
</style>
